<div class="help-icon" (click)="openMessage()"  >?</div>
<!-- <div class="help-icon" (click)="openMessage()" [matTooltip]="message" >?</div> -->
<!-- <div ><mat-icon>question_mark</mat-icon></div> -->
<!-- <div class="popup" *ngIf="isVisible" (click)="closePopup($event)">
  <p>{{ message }}</p>
  <button (click)="closePopup($event)">閉じる</button>
</div> -->

<!-- ポップアップウィンドウ -->
 <!--
<div class="popup-overlay" *ngIf="isVisible" (click)="closePopup($event)">
  <div class="popup-content" (click)="$event.stopPropagation()">
    <p>{{ message }}</p>
    <button (click)="closePopup($event)">閉じる</button>
  </div>
</div>
-->